export default __webpack_public_path__ + "protected-area-500-37628a45a573d70b3ea403a84626aab5.png";